<template>
    <div :id="id" class="tree_item_container" :class="{active: selected}">
        <p class="tree-item" :style="itemStyle" @click.stop="selectCategory()" :class="{spacer: id===0}">
            <span v-if="hasChilds" @click.stop="expand(id, $event)">
                <svg :class="{is_expanded: expanded}" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                </svg>
            </span>
            {{ title }}
        </p>
    </div>
</template>

<script>

export default {
    name: "NestedItem",
    emits: ['expand', 'selectcategory'],
    props: {
        title: {
            type: String
        },
        id: {
            type: [Number, String]
        },
        childs: {
            type: Array,
            default: () => []
        },
        expanded: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Boolean,
            default: false
        },
        level: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
        }
    },

    watch: {
        hasChilds: {
            immediate: true,
            handler: (value, oldValue) => {
                if (!value && oldValue && this.expanded) {
                    context.emit('expand', {
                        expand: false,
                        id: this.id
                    })
                }
            }
        }
    },

    computed: {
        itemStyle() {
            return { 'padding-left': this.level * 1.8 + 'em' };
        },
        hasChilds() {
            return !!this.childs.length
        },
    },

    methods: {
        expand(id, event) {
            if (!this.hasChilds) return
            const expanded = !this.expanded;
            this.$emit('expand', { expanded, id: this.id });
        },
        selectCategory() {
            if (this.type) {
                this.$emit('selectcategory', {id: this.id, type: this.type} );
            } else {
                this.$emit('selectcategory', this.id );
            }
        },
    },
}
</script>

<style scoped>
.ja-center {
    display: flex;
    align-items: center;
    justify-content: center;
}
.tree-item {
    display: flex;
    align-items: center;
    gap: 5px;
    min-height: 32px;
    color: #212529;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
    cursor: pointer;
}
.tree-item span {
    display: flex;
    align-items: center;
    padding: 0 10px;
    height: 30px;
}
.tree-item span:hover {
    border-radius: 4px;
    background-color: #a6d4ff;
}

.tree_item_container {
    border-bottom: 1px solid #C8E4FF;
}

.is_expanded {
    transform: rotate(180deg);
}

.tree_item_container:hover {
    background: #eef7ff;
}
.tree_item_container.active {
    background: #C8E4FF;
}

.item_table {
    width: 100%;
    text-align: left;
}

.item_table tr {
    display: flex;
}

.item_table th {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    word-break: break-word;
}

.d-flex {
    display: flex;
    align-items: center;
    gap: 11px;
}

.product-item {
    cursor: pointer;
}

.item_card.mobile {
    display: none;
    padding: 10px;
}

.item_card.active {
    background-color: #C8E4FF;
}

.item_table.active {
    background-color: #C8E4FF;
}

.item_card_row {
    display: flex;
    gap: 20px;
}

.item_title {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin: 0;
    padding-bottom: 5px;
}

.item_code {
    color: rgba(33, 37, 41, 0.40);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
}

.item_balance {
    color: #356EEF;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
}

.item_row {
    display: flex;
    gap: 4px;
    padding-bottom: 8px;
}

.item_details {
    color: #356EEF;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
    text-decoration-line: underline;
}

.spacer {
    padding-left: 12px!important
}

@media (max-width: 800px) {
    .item_table {
        display: none!important;
    }
    .item_card.mobile {
        display: block;
    }
    .tree-item {
        height: auto;
        padding: 5px 0px;
    }
}
</style>
